import { gql } from "graphql-tag";

export const clearNotificationGQL = gql`
  mutation ClearNotifications($notificationIds: [UUID!]) {
    clearNotifications(notificationIds: $notificationIds) {
      message
    }
  }
`;
